/**
 * Generuje třídy pro odsazení a okraje na základě hodnot v rem.
 */
const spacingKeyValues = [
    { key: 0, value: 0 },
    { key: 0.5, value: 0.125 },
    { key: 1, value: 0.25 },
    { key: 1.5, value: 0.375 },
    { key: 2, value: 0.5 },
    { key: 2.5, value: 0.625 },
    { key: 3, value: 0.75 },
    { key: 3.5, value: 0.875 },
    { key: 4, value: 1 },
    { key: 5, value: 1.25 },
    { key: 6, value: 1.5 },
    { key: 7, value: 1.75 },
    { key: 8, value: 2 },
    { key: 9, value: 2.25 },
    { key: 10, value: 2.5 },
    { key: 11, value: 2.75 },
    { key: 12, value: 3 },
    { key: 14, value: 3.5 },
    { key: 16, value: 4 },
    { key: 20, value: 5 },
    { key: 24, value: 6 },
    { key: 28, value: 7 },
    { key: 32, value: 8 },
    { key: 36, value: 9 },
    { key: 40, value: 10 },
    { key: 44, value: 11 },
    { key: 48, value: 12 },
    { key: 52, value: 13 },
    { key: 56, value: 14 },
    { key: 60, value: 15 },
    { key: 64, value: 16 },
    { key: 72, value: 18 },
    { key: 80, value: 20 },
    { key: 96, value: 24 }
];
function generateSpacingClasses() {
    const spacingClasses = spacingKeyValues
        .map((spacing) => {
        const remValue = `${spacing.value}rem`;
        return {
            [`p-${spacing.key}`]: `padding: ${remValue};`,
            [`px-${spacing.key}`]: `padding-left: ${remValue}; padding-right: ${remValue};`,
            [`py-${spacing.key}`]: `padding-top: ${remValue}; padding-bottom: ${remValue};`,
            [`pt-${spacing.key}`]: `padding-top: ${remValue};`,
            [`pr-${spacing.key}`]: `padding-right: ${remValue};`,
            [`pb-${spacing.key}`]: `padding-bottom: ${remValue};`,
            [`pl-${spacing.key}`]: `padding-left: ${remValue};`,
            [`m-${spacing.key}`]: `margin: ${remValue};`,
            [`mx-${spacing.key}`]: `margin-left: ${remValue}; margin-right: ${remValue};`,
            [`my-${spacing.key}`]: `margin-top: ${remValue}; margin-bottom: ${remValue};`,
            [`mt-${spacing.key}`]: `margin-top: ${remValue};`,
            [`mr-${spacing.key}`]: `margin-right: ${remValue};`,
            [`mb-${spacing.key}`]: `margin-bottom: ${remValue};`,
            [`ml-${spacing.key}`]: `margin-left: ${remValue};`
        };
    })
        .reduce((acc, value) => {
        return { ...acc, ...value };
    }, {});
    const additionalClasses = {
        'ml-auto': 'margin-left: auto;',
        'mr-auto': 'margin-right: auto;',
        'mx-auto': 'margin-left: auto; margin-right: auto;',
        'my-auto': 'margin-top: auto; margin-bottom: auto;',
        'mt-auto': 'margin-top: auto;',
        'mb-auto': 'margin-bottom: auto;'
    };
    const result = { ...spacingClasses, ...additionalClasses };
    return result;
}
/**
 * Generuje třídy pro mezery (gap) na základě hodnot v rem.
 */
/**
 * Generuje třídy pro mezery (gap) na základě hodnot v rem.
 */
function generateGapClasses() {
    const gapClasses = spacingKeyValues
        .map((spacing) => {
        const remValue = `${spacing.value}rem`;
        return {
            [`gap-${spacing.key}`]: `gap: ${remValue};`,
            [`gap-x-${spacing.key}`]: `column-gap: ${remValue};`,
            [`gap-y-${spacing.key}`]: `row-gap: ${remValue};`
        };
    })
        .reduce((acc, value) => {
        return { ...acc, ...value };
    }, {});
    return gapClasses;
}
function generateWidthHeightClasses() {
    const widthHeightClasses = spacingKeyValues
        .map((spacing) => {
        const remValue = `${spacing.value}rem`;
        return {
            [`w-${spacing.key}`]: `width: ${remValue};`,
            [`h-${spacing.key}`]: `height: ${remValue};`
        };
    })
        .reduce((acc, value) => {
        return { ...acc, ...value };
    }, {});
    for (let i = 0; i <= 100; i++) {
        widthHeightClasses[`w-[${i}%]`] = `width: ${i}%;`;
        widthHeightClasses[`h-[${i}%]`] = `height: ${i}%;`;
    }
    return widthHeightClasses;
}
function generateBorderSpacingClasses() {
    const borderSpacingClasses = spacingKeyValues
        .map((spacing) => {
        const remValue = `${spacing.value}rem`;
        return {
            [`border-spacing-${spacing.key}`]: `border-spacing: ${remValue};`,
            [`border-spacing-x-${spacing.key}`]: `border-spacing-x: ${remValue};`,
            [`border-spacing-y-${spacing.key}`]: `border-spacing-y: ${remValue};`
        };
    })
        .reduce((acc, value) => {
        return { ...acc, ...value };
    }, {});
    return borderSpacingClasses;
}
const tailwindMap = {
    // Flexbox
    flex: 'display: flex;',
    'flex-row': 'flex-direction: row;',
    'flex-col': 'flex-direction: column;',
    'flex-wrap': 'flex-wrap: wrap;',
    'flex-nowrap': 'flex-wrap: nowrap;',
    'items-start': 'align-items: flex-start;',
    'items-end': 'align-items: flex-end;',
    'items-center': 'align-items: center;',
    'items-baseline': 'align-items: baseline;',
    'items-stretch': 'align-items: stretch;',
    'justify-start': 'justify-content: flex-start;',
    'justify-end': 'justify-content: flex-end;',
    'justify-center': 'justify-content: center;',
    'justify-between': 'justify-content: space-between;',
    'justify-around': 'justify-content: space-around;',
    'justify-evenly': 'justify-content: space-evenly;',
    grow: 'flex-grow: 1;',
    'flex-grow': 'flex-grow: 1;', // fallback pro grow
    'self-end': 'align-self: flex-end;',
    // Spacing
    ...generateSpacingClasses(),
    ...generateGapClasses(),
    ...generateWidthHeightClasses(),
    'w-1/2': 'width: 50%;',
    'w-1/3': 'width: 33.333333%;',
    'w-2/3': 'width: 66.666667%;',
    'w-1/4': 'width: 25%;',
    'w-3/4': 'width: 75%;',
    'w-1/5': 'width: 20%;',
    'w-2/5': 'width: 40%;',
    'w-3/5': 'width: 60%;',
    'w-4/5': 'width: 80%;',
    'h-1/2': 'height: 50%;',
    'h-1/3': 'height: 33.333333%;',
    'h-2/3': 'height: 66.666667%;',
    'h-1/4': 'height: 25%;',
    'h-3/4': 'height: 75%;',
    'h-1/5': 'height: 20%;',
    'h-2/5': 'height: 40%;',
    'h-3/5': 'height: 60%;',
    'h-4/5': 'height: 80%;',
    // Typography
    'text-xs': 'font-size: 0.75rem; line-height: 1rem;',
    'text-sm': 'font-size: 0.875rem; line-height: 1.25rem;',
    'text-base': 'font-size: 1rem; line-height: 1.5rem;',
    'text-lg': 'font-size: 1.125rem; line-height: 1.75rem;',
    'text-xl': 'font-size: 1.25rem; line-height: 1.75rem;',
    'text-2xl': 'font-size: 1.5rem; line-height: 2rem;',
    'text-3xl': 'font-size: 1.875rem; line-height: 2.25rem;',
    'text-4xl': 'font-size: 2.25rem; line-height: 2.5rem;',
    'text-5xl': 'font-size: 3rem; line-height: 1;',
    'text-6xl': 'font-size: 3.75rem; line-height: 1;',
    'font-thin': 'font-weight: 100;',
    'font-extralight': 'font-weight: 200;',
    'font-light': 'font-weight: 300;',
    'font-normal': 'font-weight: 400;',
    'font-medium': 'font-weight: 500;',
    'font-semibold': 'font-weight: 600;',
    'font-bold': 'font-weight: 700;',
    'font-extrabold': 'font-weight: 800;',
    'font-black': 'font-weight: 900;',
    italic: 'font-style: italic;',
    'not-italic': 'font-style: normal;',
    'text-center': 'text-align: center;',
    'text-left': 'text-align: left;',
    'text-right': 'text-align: right;',
    'text-justify': 'text-align: justify;',
    uppercase: 'text-transform: uppercase;',
    lowercase: 'text-transform: lowercase;',
    capitalize: 'text-transform: capitalize;',
    'normal-case': 'text-transform: none;',
    underline: 'text-decoration: underline;',
    'line-through': 'text-decoration: line-through;',
    'no-underline': 'text-decoration: none;',
    // Colors (příklady, skutečné barvy by závisely na vaší Tailwind konfiguraci)
    'text-black': 'color: #000000;',
    'text-white': 'color: #ffffff;',
    'text-gray-500': 'color: #6b7280;',
    'text-blue-600': 'color: #2563eb;',
    'text-red-500': 'color: #ef4444;',
    'bg-white': 'background-color: #ffffff;',
    'bg-black': 'background-color: #000000;',
    'bg-gray-100': 'background-color: #f3f4f6;',
    'bg-blue-500': 'background-color: #3b82f6;',
    // Borders
    border: 'border-width: 1px;',
    'border-0': 'border-width: 0;',
    'border-2': 'border-width: 2px;',
    'border-4': 'border-width: 4px;',
    'border-t': 'border-top-width: 1px;',
    'border-r': 'border-right-width: 1px;',
    'border-b': 'border-bottom-width: 1px;',
    'border-l': 'border-left-width: 1px;',
    'border-solid': 'border-style: solid;',
    'border-dashed': 'border-style: dashed;',
    'border-dotted': 'border-style: dotted;',
    'border-double': 'border-style: double;',
    'border-none': 'border-style: none;',
    'rounded-none': 'border-radius: 0;',
    'rounded-sm': 'border-radius: 0.125rem;',
    rounded: 'border-radius: 0.25rem;',
    'rounded-md': 'border-radius: 0.375rem;',
    'rounded-lg': 'border-radius: 0.5rem;',
    'rounded-full': 'border-radius: 9999px;',
    'border-b-2': 'border-bottom-width: 2px;',
    'border-black': 'border-color: #000000;',
    'border-collapse': 'border-collapse: collapse;',
    // Layout
    'w-full': 'width: 100%;',
    'w-auto': 'width: auto;',
    'w-screen': 'width: 100vw;',
    'h-full': 'height: 100%;',
    'h-auto': 'height: auto;',
    'h-screen': 'height: 100vh;',
    'min-w-0': 'min-width: 0;',
    'min-w-full': 'min-width: 100%;',
    'min-h-0': 'min-height: 0;',
    'min-h-full': 'min-height: 100%;',
    'max-w-none': 'max-width: none;',
    'max-w-full': 'max-width: 100%;',
    'max-h-full': 'max-height: 100%;',
    'max-h-screen': 'max-height: 100vh;',
    // Positioning
    static: 'position: static;',
    fixed: 'position: fixed;',
    absolute: 'position: absolute;',
    relative: 'position: relative;',
    sticky: 'position: sticky;',
    'inset-0': 'top: 0; right: 0; bottom: 0; left: 0;',
    'top-0': 'top: 0;',
    'right-0': 'right: 0;',
    'bottom-0': 'bottom: 0;',
    'left-0': 'left: 0;',
    // Display
    block: 'display: block;',
    'inline-block': 'display: inline-block;',
    inline: 'display: inline;',
    hidden: 'display: none;',
    table: 'display: table;',
    'table-row': 'display: table-row;',
    'table-cell': 'display: table-cell;',
    // Overflow
    'overflow-auto': 'overflow: auto;',
    'overflow-hidden': 'overflow: hidden;',
    'overflow-visible': 'overflow: visible;',
    'overflow-scroll': 'overflow: scroll;',
    'overflow-x-auto': 'overflow-x: auto;',
    'overflow-y-auto': 'overflow-y: auto;',
    // Z-index
    'z-0': 'z-index: 0;',
    'z-10': 'z-index: 10;',
    'z-20': 'z-index: 20;',
    'z-30': 'z-index: 30;',
    'z-40': 'z-index: 40;',
    'z-50': 'z-index: 50;',
    // Opacity
    'opacity-0': 'opacity: 0;',
    'opacity-25': 'opacity: 0.25;',
    'opacity-50': 'opacity: 0.5;',
    'opacity-75': 'opacity: 0.75;',
    'opacity-100': 'opacity: 1;',
    // Miscellaneous
    'shadow-sm': 'box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);',
    shadow: 'box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);',
    'shadow-md': 'box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);',
    'shadow-lg': 'box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);',
    'shadow-xl': 'box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);',
    'shadow-2xl': 'box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);',
    'shadow-inner': 'box-shadow: inset 0 2px 4px 0 rgba(0, 0, 0, 0.06);',
    'shadow-none': 'box-shadow: none;',
    'cursor-pointer': 'cursor: pointer;',
    'cursor-not-allowed': 'cursor: not-allowed;',
    'select-none': 'user-select: none;',
    'select-text': 'user-select: text;',
    'select-all': 'user-select: all;',
    'select-auto': 'user-select: auto;',
    'whitespace-normal': 'white-space: normal;',
    'whitespace-nowrap': 'white-space: nowrap;',
    'whitespace-pre': 'white-space: pre;',
    'whitespace-pre-line': 'white-space: pre-line;',
    'whitespace-pre-wrap': 'white-space: pre-wrap;',
    'break-normal': 'overflow-wrap: normal; word-break: normal;',
    'break-words': 'overflow-wrap: break-word;',
    'break-all': 'word-break: break-all;',
    truncate: 'overflow: hidden; text-overflow: ellipsis; white-space: nowrap;',
    transition: 'transition-property: background-color, border-color, color, fill, stroke, opacity, box-shadow, transform; transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1); transition-duration: 150ms;',
    // Align
    'align-top': 'vertical-align: top;',
    'align-middle': 'vertical-align: middle;',
    'align-bottom': 'vertical-align: bottom;',
    'align-text-top': 'vertical-align: text-top;',
    'align-text-bottom': 'vertical-align: text-bottom;',
    'align-baseline': 'vertical-align: baseline;',
    'align-sub': 'vertical-align: sub;',
    'align-super': 'vertical-align: super;',
    // Breaks
    'break-inside-avoid': 'break-inside: avoid;',
    'break-after-auto': 'break-after: auto;',
    'break-before-auto': 'break-before: auto;',
    'break-inside-auto': 'break-inside: auto;',
    'break-inside-avoid-page': 'break-inside: avoid-page;',
    'break-inside-avoid-column': 'break-inside: avoid-column;',
    'break-inside-avoid-region': 'break-inside: avoid-region;',
    'break-inside-avoid-page-column': 'break-inside: avoid-page-column;',
    'break-inside-avoid-page-region': 'break-inside: avoid-page-region;',
    'break-inside-avoid-column-region': 'break-inside: avoid-column-region;',
    // Přidání nových tříd pro border-spacing
    ...generateBorderSpacingClasses()
};
export function tailwindToInlineStyle(tailwindClasses) {
    const classes = tailwindClasses.split(' ');
    const styles = [];
    const unsupportedClasses = [];
    for (const cls of classes) {
        if (tailwindMap[cls]) {
            styles.push(tailwindMap[cls]);
        }
        else {
            unsupportedClasses.push(cls);
        }
    }
    if (unsupportedClasses.length > 0) {
        throw new Error(`Nepodporované Tailwind třídy: ${unsupportedClasses.join(', ')}. Přidej třidy do souboru tailwind.util.ts`);
    }
    return styles.join(' ');
}
//# sourceMappingURL=tailwind.util.js.map